document.addEventListener('DOMContentLoaded', function() {

    // --- Set Current Year in Footer ---
    const currentYearSpan = document.getElementById('current-year');
    if (currentYearSpan) {
        currentYearSpan.textContent = new Date().getFullYear();
    }

    // --- Simple Parallax Effect for Hero Background ---
    const parallaxBg = document.querySelector('#home .parallax-bg');

    if (parallaxBg) {
        window.addEventListener('scroll', function() {
            const scrollPosition = window.pageYOffset;
            // Adjust the '0.3' value to change the speed of the parallax effect
            // Lower value = slower movement (more pronounced parallax)
            parallaxBg.style.transform = 'translateY(' + scrollPosition * 0.3 + 'px)';
        });
    }

    // --- Smooth Scrolling for Navigation Links ---
    const navLinks = document.querySelectorAll('nav a[href^="#"]');

    navLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault(); // Prevent default jump

            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                // Calculate offset position, considering potential sticky header
                const headerOffset = document.getElementById('main-header') ? document.getElementById('main-header').offsetHeight : 0;
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });

    // --- Contact Formspree Helper ---
    // Optional: Add some JS feedback after form submission if using Formspree AJAX submit
    const contactForm = document.querySelector('.contact-form form');
    if (contactForm && contactForm.action.includes('formspree')) {
        contactForm.addEventListener('submit', async function(e) {
            // You could add more advanced handling here if needed
            // e.preventDefault(); // Uncomment this if you want to handle submission fully via JS (AJAX)
            // Show a "Sending..." message, etc.
            console.log('Form submitted (or would be submitted) to Formspree.');
        });
    }

});